'use strict';
module.exports = require('./Dropdown.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/dropdown/index.js
// module id = 97
// module chunks = 7